import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import "../css/AddDeviceNew.css";
// import Cookies from 'js-cookie';
// import { styled } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import IntegrationReactSelectNew from "./IntegrationReactSelectNew";
import uniqid from "uniqid";
// import 'antd/dist/antd.css';
import ErrorText from "../ErrorText";
import deviceDriverUpdate from "../deviceDriverUpdate";
import InputBox from "./InputBox";
import _, { values } from "lodash";
import IconButton from "@mui/material/IconButton";
import ListIcon from "@mui/icons-material/List";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip, OverlayTrigger, Overlay, FormControl } from "react-bootstrap";
import Loader from "./Loader";
import SnackBar from "./SnackBar";
import * as ActionTypes from "../actions/types";
import { connect } from "react-redux";
import processDriverData from "../processDriverData";
import { Box, Button, FormHelperText, TextField } from "@mui/material";

//component for the add new device for the master page having device params sent in json format
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "70%",
    overflow: "auto",
    padding: "40px 90px 40px 90px",
    paddingBottom: "4%",
    marginLeft: "260px",
    marginTop: "3%",
    background: "#EFF3F6",
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

const customStylesSuccess = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    minHeight: "50%",
    maxHeight: "70%",
    overflow: "auto",
    padding: "2%",
    marginLeft: "260px",
    marginTop: "3%",
    background: "#EFF3F6",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none",
  },
};

const deviceTypeList = [
  { label: "light_cover" },
  { label: "tv" },
  { label: "projector" },
  { label: "bluray" },
  { label: "thermostat" },
  { label: "avp" },
  { label: "lift" },
  { label: "toggle_lift" },
  { label: "swivel_lift" },
  { label: "media_player" },
  { label: "satellite" },
  { label: "camera" },
  { label: "security_system" },
  { label: "door_phone" },
  { label: "access_control" },
  { label: "IR" },
  { label: "Device IR" },
  { label: "RS232" },
  { label: "audio_matrix_switcher" },
  { label: "Other Devices" },
  { label: "Device RS232" },
  { label: "Device RS232" },
];
const deviceDriverList = [{ label: "custom" }, { label: "inbuilt" }];

const connTypeStat = [{ label: "IP" }, { label: "RS232" }, { label: "CEC" }];

const deviceMode = [{ label: "device" }, { label: "utility" }];

const ioType = [
  { label: "input" },
  { label: "output" },
  { label: "process" },
  { label: "other" },
];

const styles = (theme) => ({
  root: {
    display: "flex",
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%",
    border: "none",
  },
  selectEmpty: {
    // marginTop: theme.spacing.unit * 2,
    width: "100%",
  },
  margin: {
    // margin: theme.spacing.unit,
    // margin: 0,
    width: "10px",
  },
  extendedIcon: {
    // marginRight: theme.spacing.unit,
  },
});

class AddDeviceNew1 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: this.props.activeModal,
      modalIsOpenSuccess: false,
      allError: [],
      showErrorMessage: false,
      modalStateAftereOpen: "animated animated-duration-custom slideInDown",
      modalStateAftereOpenSuccess:
        "animated animated-duration-custom slideInDown",
      //states for adding device:
      deviceType: "",
      deviceDriver: "",
      deviceName: "",
      deviceNickName: "",
      deviceModel: "",
      deviceConnectionType: [],
      deviceMode: "",
      deviceNotes: "",
      deviceVersion: "",
      ioType: "",
      notes: "",
      noOfExtraField: "",
      extraFields: "",
      errorMessage: [],
      driverData: [],
      errorInJSON: false,
      showErrorMessageJSON: false,
      validateDriverData: false,
      snackbarActive: false,
      snackbarMessage: "",
      loader: false,
      // Driver related states
      driverVersion: "",
      driverVersionError: false,
      packagePath: "",
      document: "",
      fileErrorText: "",
      itemList: [], // Initialize itemList
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalSuccess = this.closeModalSuccess.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModalSuccess() {
    let uniquePath = uniqid();
    let xx = [
      {
        paramField: "",
        paramUniqueKey: uniquePath,
        paramValues: [
          {
            paramField: "",
            paramUniqueKey: uniqid(),
            paramValues: [],
            path: `root/0/${uniquePath}/0`,
            type: "root",
          },
        ],
        path: "root/0",
        type: "root",
      },
    ];
    this.props.deviceUpdate(xx);
    this.setState(
      {
        modalStateAftereOpenSuccess:
          "animated animated-duration-custom slideOutUp",
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpenSuccess: false,
            },
            () => this.props.refreshDevice()
          );
        }, 500);
      }
    );
  }

  closeModal(e) {
    e.preventDefault();
    let uniquePath = uniqid();
    let xx = [
      {
        paramField: "",
        paramUniqueKey: uniquePath,
        paramValues: [
          {
            paramField: "",
            paramUniqueKey: uniqid(),
            paramValues: [],
            path: `root/0/${uniquePath}/0`,
            type: "root",
          },
        ],
        path: "root/0",
        type: "root",
      },
    ];
    this.props.deviceUpdate(xx);
    this.setState(
      {
        modalStateAftereOpen: "animated animated-duration-custom slideOutUp",
        //states for adding device:
        deviceType: "",
        deviceDriver: "",
        deviceName: "",
        deviceNickName: "",
        deviceModel: "",
        deviceConnectionType: "",
        deviceMode: "",
        ioType: "",
        notes: "",
        errorMessage: [],
        // Reset driver states
        driverVersion: "",
        driverVersionError: false,
        packagePath: "",
        document: "",
        fileErrorText: "",
        itemList: [],
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              modalIsOpen: false,
            },
            () => {
              this.props.refreshDevice();
            }
          );
        }, 500);
      }
    );
  }

  handleChangeInputBox = (name, event) => {
    let xx = {
      errorField: name,
      errorContent: event,
    };
    let allError = this.state.allError;

    let compressedError = _.remove(allError, (e) => {
      return e[name] !== "";
    });
    allError.push(xx);

    this.setState({
      [name]: event,
      allError: compressedError,
    });
  };

  AddDevice = (e) => {
    e.preventDefault();
    if (!this.state.errorInJSON) {
      this.fetchError((e) => {
        if (e === "NoError") {
          this.setState(
            {
              loader: true,
            },
            () => this.AddDeviceNew()
          );
        }
      });
    }
  };

  validateDriverData = (e) => {
    e.preventDefault();
    this.setState(
      {
        showErrorMessageJSON: true,
        errorInJSON: false,
        validateDriverData: true,
        showErrorMessage: true,
      },
      () => {
        if (this.state.extraFields.length !== 0) {
          // this.countMyArray(this.state.extraFields)
          this.countMyArray(this.props.redux.auth.deviceApi);
        } else {
          this.setState({
            errorInJSON: true,
          });
        }
      }
    );
  };

  fetchError = (noErrorCallBack) => {
    var errorMessage = [];

    this.setState({
      showErrorMessage: true,
    });

    // Required fields validation
    if (this.state.deviceType.length === 0) {
      errorMessage.push("Device type missing or incorrect");
    }

    if (this.state.deviceName.length === 0) {
      errorMessage.push("Device name missing or incorrect");
    }

    if (this.state.deviceModel.length === 0) {
      errorMessage.push("Device model missing or incorrect");
    }

    if (this.state.deviceNotes.length === 0) {
      errorMessage.push("Device notes missing or incorrect");
    }

    if (this.state.deviceConnectionType.length === 0) {
      errorMessage.push("Device connection type missing or incorrect");
    }

    if (this.state.deviceMode.length === 0) {
      errorMessage.push("Device mode missing or incorrect");
    }

    if (this.state.deviceMode === "device") {
      if (this.state.ioType.length === 0) {
        errorMessage.push("Device input/output type missing or incorrect");
      }
    }

    // Optional driver validation - only validate if user started adding drivers
    if (this.state.itemList && this.state.itemList.length > 0) {
      const hasIncompleteDriver = this.state.itemList.some((item) => {
        return (
          !item.deviceDriver ||
          !item.driverVersion ||
          !item.packagePath ||
          !item.document
        );
      });

      if (hasIncompleteDriver) {
        errorMessage.push(
          "All driver fields must be completed if adding drivers"
        );
      }

      // Validate driver version format
      const hasInvalidVersion = this.state.itemList.some((item) => {
        const versionRegex = /^\d+\.\d+\.\d+$/;
        return item.driverVersion && !versionRegex.test(item.driverVersion);
      });

      if (hasInvalidVersion) {
        errorMessage.push("Driver version format must be X.Y.Z (e.g., 1.0.0)");
      }
    }

    this.setState(
      {
        errorMessage: errorMessage,
      },
      () => {
        if (this.state.errorMessage.length === 0) {
          noErrorCallBack("NoError");
        }
      }
    );
  };

  countMyArray = (someArray) => {
    someArray.forEach((element) => {
      if (ErrorText("notEmpty", element.paramField) !== "No Error") {
        this.setState({
          errorInJSON: true,
        });
      }
      if (element.paramValues.length !== 0) {
        this.countMyArray(element.paramValues);
      }
    });
  };

  AddDeviceNew = (e) => {
    let device_type = this.state.deviceType;
    let device_name = this.state.deviceName;
    let device_model = this.state.deviceModel;
    let device_connection = this.state.deviceConnectionType;
    let device_group = this.state.deviceMode;
    let device_io = this.state.ioType;
    let device_notes = this.state.deviceNotes;
    let device_extra_field = processDriverData(this.state.extraFields);

    var tokenStored = localStorage.getItem("token");
    tokenStored = `Token ${tokenStored}`;

    var headers = {
      "Access-Control-Allow-Origin": "*",
      "X-CSRFToken": localStorage.getItem("csrftoken"),
      Authorization: tokenStored,
    };

    this.setState({
      loader: true,
    });

    // Create FormData
    const formData = new FormData();

    // Build the base payload
    const requestBody = {
      device_type: device_type,
      device_name: device_name,
      device_model: device_model,
      device_connection: device_connection.map((item) => ({
        label: item,
        value: item,
      })),
      device_group: device_group,
      device_io: device_io,
      device_notes: device_notes,
      device_extra_field: device_extra_field,
    };

    // Add drivers only if itemList exists and has valid data
    if (this.state.itemList && this.state.itemList.length > 0) {
      // Validate each driver item before adding
      const validDrivers = this.state.itemList.filter((item) => {
        return (
          item.deviceDriver &&
          item.driverVersion &&
          item.packagePath &&
          item.document
        );
      });

      if (validDrivers.length > 0) {
        requestBody.drivers = validDrivers.map((item) => ({
          device_driver: item.deviceDriver,
          device_version: item.driverVersion,
          package_path: item.packagePath?.name || "",
          document: item.document?.name || "",
        }));
      } else {
        // If itemList exists but no valid drivers, send empty array
        requestBody.drivers = [];
      }
    }
    // If no itemList, don't include drivers in payload at all

    // Append JSON payload
    formData.append("data", JSON.stringify(requestBody));

    // Append actual files only if drivers exist and are valid
    if (this.state.itemList && this.state.itemList.length > 0) {
      this.state.itemList.forEach((item, index) => {
        // Only append files if they exist and are valid
        if (item.packagePath instanceof File) {
          formData.append(`package_file_${index}`, item.packagePath);
        }
        if (item.document instanceof File) {
          formData.append(`document_file_${index}`, item.document);
        }
      });
    }

    fetch("/cloud/device_cloudApi/", {
      method: "POST",
      headers: headers,
      body: formData,
    })
      .then((response) => {
        if (response.status === 403) {
          localStorage.removeItem("token");
          localStorage.removeItem("csrftoken");
          localStorage.removeItem("auth");
          window.location.href = "/session-timeout";
        } else {
          return response.json();
        }
      })
      .then((data) => {
        if (data.message === "failure") {
          var errorMessage = [];
          errorMessage.push(data.data.device_model[0]);
          this.setState({
            errorMessage: errorMessage,
            snackbarActive: true,
            snackbarMessage: data.data.device_model[0],
            loader: false,
          });
        } else {
          this.setState({
            modalIsOpen: false,
            modalIsOpenSuccess: true,
            loader: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
          snackbarActive: true,
          snackbarMessage: "An error occurred while adding the device",
        });
      });
  };

  onSelectChange = (operationMode, valueSelect) => {
    let xx = {
      errorField: operationMode,
      errorContent: valueSelect,
    };
    let allError = this.state.allError;
    allError.push(xx);

    if (operationMode === "deviceType") {
      this.setState({
        deviceType: valueSelect,
        errorMessage: [],
        allError,
      });
    } else if (operationMode === "deviceDriver") {
      this.setState({
        deviceDriver: valueSelect,
        errorMessage: [],
        allError,
      });
    } else if (operationMode === "deviceMode") {
      this.setState({
        deviceMode: valueSelect,
        errorMessage: [],
        allError,
      });
    } else if (operationMode === "connType") {
      this.setState({
        deviceConnectionType: valueSelect,
        errorMessage: [],
        allError,
      });
    } else if (operationMode === "ioType") {
      this.setState({
        ioType: valueSelect,
        errorMessage: [],
        allError,
      });
    }
  };

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedExtensions = [".zip", ".bin"];
      const fileExt = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      if (!allowedExtensions.includes(fileExt)) {
        this.setState({
          fileErrorText: "Only .zip or .bin files are allowed.",
          showErrorMessage: true,
          packagePath: null,
          document: null,
        });
        event.target.value = "";
        return;
      }

      this.setState({
        packagePath: file,
        document: file, // ✅ keep the File object
        fileErrorText: "",
        showErrorMessage: false,
      });
    }
  };

  errorLog = (data) => {
    let errorLog = {
      ...this.props.redux.auth.deviceDriverError,
      [data.path]: data.paramField === "" ? true : false,
    };
    if (data.paramValues.length === 0) {
      this.props.deviceError(errorLog);
      //  console.log('called')
    } else {
      this.props.deviceError(errorLog);
      let dataNew = {
        ...data.paramValues[0],
      };
      this.errorLog(dataNew);
    }
  };

  renderBoxTypeFirst = (data, callBackRoot) => {
    let dataLength = data.length;
    callBackRoot = (path, data, type, position) => {
      if (type === "root") {
        let uniquePath = uniqid();
        let lastIndexValue = path.lastIndexOf("/");
        let extractedPath = path.substring(lastIndexValue + 1, path.length);
        let previousPath = path.substring(0, lastIndexValue);
        let dataNew = {
          paramField: "",
          paramUniqueKey: uniquePath,
          paramValues: [
            {
              paramField: "",
              paramUniqueKey: uniquePath,
              paramValues: [],
              path: `${previousPath}/${dataLength}/${uniquePath}/0`,
              type: "root",
            },
          ],
          path: `${previousPath}/${data.length}`,
          type: "root",
        };
        data.push(dataNew);
        this.errorLog(dataNew);
        let searchingData = this.props.redux.auth.deviceApi;
        let lastIndexValueNew = path.lastIndexOf("/");
        let extractedPathNew = path.substring(0, lastIndexValueNew);
        let lastIndexValueSecond = extractedPathNew.lastIndexOf("/");
        let extractedPathSecond = extractedPathNew.substring(
          0,
          lastIndexValueSecond
        );
        let someData = this.iterateOverObj(
          extractedPathSecond,
          searchingData,
          dataNew
        );
        this.updateDeviceData(path, someData);
      } else if (type === "fruit") {
        let uniquePath = uniqid();
        let lastIndexValue = path.lastIndexOf("/");
        let extractedPath = path.substring(lastIndexValue + 1, path.length);
        let previousPath = path.substring(0, lastIndexValue);
        let dataNew = {
          paramField: "",
          paramUniqueKey: uniquePath,
          paramValues: [],
          path: `${previousPath}/${data.length}`,
          type: "root",
        };
        data.push(dataNew);
        this.errorLog(dataNew);
        let searchingData = this.props.redux.auth.deviceApi;
        let lastIndexValueNew = path.lastIndexOf("/");
        let extractedPathNew = path.substring(0, lastIndexValueNew);
        let lastIndexValueSecond = extractedPathNew.lastIndexOf("/");
        let extractedPathSecond = extractedPathNew.substring(
          0,
          lastIndexValueSecond
        );
        let someData = this.iterateOverObj(
          extractedPathSecond,
          searchingData,
          dataNew
        );
        this.updateDeviceData(path, someData);
      }
    };
    let element = "";
    if (data.length !== undefined) {
      element = data.map((e, index) => {
        let innerElement = "";
        let valueParam = "";
        if (e.type === "root") {
          valueParam = e.paramField;
          if (e.paramValues.length !== 0) {
            innerElement = this.renderBoxTypeFirst(e.paramValues);
          }
        } else if (e.type === "fruit") {
          valueParam = e.paramField;
        }
        // console.log(e)
        return (
          <React.Fragment>
            {/* <div style={{ marginLeft: e.path.length<= 8 ? '0px' : '20px' }}> */}
            <div style={{ marginLeft: "20px" }}>
              {this.state.showErrorMessageJSON &&
              ErrorText("notEmpty", valueParam) !== "No Error" ? (
                <span className="small text-danger">Not a valid input</span>
              ) : (
                <span></span>
              )}
              <div class="d-flex bd-highlight">
                <div class="p-2 flex-grow-1 bd-highlight">
                  <input
                    type="text"
                    class="form-control"
                    value={valueParam}
                    onChange={(x) => {
                      if (x.target.value.length <= 50) {
                        let updatedData = deviceDriverUpdate(
                          e.path,
                          this.props.redux.auth.deviceApi,
                          x.target.value,
                          "add"
                        );
                        let errorLog = this.props.redux.auth.deviceDriverError;
                        errorLog = {
                          ...this.props.redux.auth.deviceDriverError,
                          [e.path]: x.target.value === "" ? true : false,
                        };
                        this.props.deviceError(errorLog);
                        this.updateDeviceData("paramKey", updatedData);
                        this.setState({
                          extraFields: updatedData,
                          errorInJSON: false,
                          validateDriverData: false,
                        });
                      }
                    }}
                  />
                </div>
                {data.length !== 1 ? (
                  <OverlayTrigger
                    placement="auto"
                    display={false}
                    overlay={<Tooltip id="overlay-example">Delete</Tooltip>}
                  >
                    <div>
                      <React.Fragment>
                        <IconButton aria-label="Delete">
                          <DeleteIcon
                            onClick={(x) => {
                              let updatedData = deviceDriverUpdate(
                                e.path,
                                this.props.redux.auth.deviceApi,
                                "delete",
                                "delete"
                              );
                              this.props.deviceUpdate(updatedData);
                              this.setState({
                                errorInJSON: false,
                                validateDriverData: false,
                              });
                            }}
                          />
                        </IconButton>
                      </React.Fragment>
                    </div>
                  </OverlayTrigger>
                ) : null}
                <React.Fragment>
                  {data.length === index + 1 && e.path.length <= 31 ? (
                    <OverlayTrigger
                      placement="auto"
                      display={false}
                      overlay={
                        <Tooltip id="overlay-example">With Label</Tooltip>
                      }
                    >
                      <div>
                        <React.Fragment>
                          <IconButton aria-label="Delete">
                            <ListIcon
                              onClick={(someRender) => {
                                this.setState(
                                  {
                                    errorInJSON: false,
                                    validateDriverData: false,
                                  },
                                  () => {
                                    someRender.preventDefault();
                                    callBackRoot(e.path, data, "root", index);
                                  }
                                );
                              }}
                            />
                          </IconButton>
                        </React.Fragment>
                      </div>
                    </OverlayTrigger>
                  ) : null}
                  {e.paramValues.length === 0 && data.length === index + 1 ? (
                    <OverlayTrigger
                      placement="auto"
                      display={false}
                      overlay={
                        <Tooltip id="overlay-example">Without Label</Tooltip>
                      }
                    >
                      <div>
                        <React.Fragment>
                          <IconButton aria-label="Delete">
                            <AddIcon
                              onClick={(someRender) => {
                                this.setState(
                                  {
                                    errorInJSON: false,
                                    validateDriverData: false,
                                  },
                                  () => {
                                    someRender.preventDefault();
                                    callBackRoot(e.path, data, "fruit", index);
                                  }
                                );
                              }}
                            />
                          </IconButton>
                        </React.Fragment>
                      </div>
                    </OverlayTrigger>
                  ) : null}
                </React.Fragment>
              </div>
              {innerElement}
            </div>
          </React.Fragment>
        );
      });
    }
    return element;
  };

  updateDeviceData = (path, updatePartialData) => {
    let previousState = this.props.redux.auth.deviceApi;
    this.props.deviceUpdate(updatePartialData);
    // console.log(updatePartialData)
  };

  iterateOverObj = (path, searchingData, injectionData) => {
    let iterateAgain = true;
    iterateAgain = searchingData.some((e) => {
      if (e.path === path) {
        // searchingData['paramValues'] = injectionData;
        iterateAgain = false;
      } else if (path === "") {
        iterateAgain = false;
      }
    });
    if (iterateAgain) {
      searchingData.forEach((e) => {
        this.iterateOverObj(path, searchingData.paramValues, injectionData);
      });
    }
    if (!iterateAgain) {
      return searchingData;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <SnackBar
          open={this.state.snackbarActive}
          handleSnackbarClose={() => {
            this.setState({
              snackbarActive: false,
            });
          }}
          message={this.state.snackbarMessage}
        />
        {this.state.loader ? <Loader /> : null}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          style={customStyles}
          className={this.state.modalStateAftereOpen}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3
            className="modal-heading text-uppercase mb-0"
            style={{
              color: "#888888",
              fontSize: "30px",
              marginBottom: "30px",
              marginLeft: "-12px",
            }}
          >
            Add Device
          </h3>
          <form>
            <div className="row">
              <div className="col-6 mt-3 pl-1">
                <IntegrationReactSelectNew
                  placeholder=""
                  multipleSelect={false}
                  content={deviceTypeList}
                  onSelect={this.onSelectChange.bind(this, "deviceType")}
                  IntegrationReactSelectNewLabel="Device Type"
                  errorText={
                    this.state.deviceType === "" && this.state.showErrorMessage
                      ? "Please select device type"
                      : ""
                  }
                />
              </div>
              <div className="col-6 mt-0 px-0">
                <InputBox
                  inputText={this.state.deviceName}
                  error={
                    ErrorText("notEmpty", this.state.deviceName) !==
                      "No Error" && this.state.showErrorMessage
                  }
                  errorText={
                    ErrorText("notEmpty", this.state.deviceName) !==
                      "No Error" && this.state.showErrorMessage
                      ? "Device name must not be empty"
                      : ""
                  }
                  // inputText={this.state.deviceName}
                  placeholder="Device Name"
                  inputBoxName="deviceName"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  textLength={50}
                  validate={true}
                />
              </div>
              <div className="col-6 mb-2 p-0" style={{ marginLeft: "-4px" }}>
                <InputBox
                  inputText={this.state.deviceModel}
                  error={
                    this.state.deviceModel === "" && this.state.showErrorMessage
                  }
                  errorText={
                    ErrorText("notEmpty", this.state.deviceModel) !==
                      "No Error" && this.state.showErrorMessage
                      ? "Device model must not be empty"
                      : ""
                  }
                  // inputText={this.state.deviceModel}
                  placeholder="Device Model(Must be unique)"
                  inputBoxName="deviceModel"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  textLength={50}
                  validate={true}
                />
              </div>
              <div className="col-6 mb-2 px-0" style={{ marginLeft: "4px" }}>
                <InputBox
                  inputText={this.state.deviceNotes}
                  error={
                    this.state.deviceNotes === "" && this.state.showErrorMessage
                  }
                  errorText={
                    ErrorText("notEmpty", this.state.deviceNotes) !==
                      "No Error" && this.state.showErrorMessage
                      ? "Device notes must not be empty"
                      : ""
                  }
                  // inputText={this.state.deviceNotes}
                  placeholder="Device Notes"
                  inputBoxName="deviceNotes"
                  handleChangeCustom={this.handleChangeInputBox.bind(this)}
                  textLength={50}
                  validate={true}
                />
              </div>
              <div
                className="col-6 mt-3 mb-3"
                style={{ marginLeft: "-10px", paddingRight: "0px" }}
              >
                <IntegrationReactSelectNew
                  placeholder="Device Mode"
                  multipleSelect={false}
                  content={deviceMode}
                  onSelect={this.onSelectChange.bind(this, "deviceMode")}
                  IntegrationReactSelectNewLabel="Device Mode"
                  errorText={
                    this.state.deviceMode === "" && this.state.showErrorMessage
                      ? "Please select device mode"
                      : ""
                  }
                />

                {this.state.deviceMode === "device" ? (
                  <div className="col-12 text-field-modal pl-0 mt-4 pr-0">
                    <IntegrationReactSelectNew
                      placeholder="Input / Output Type"
                      multipleSelect={false}
                      content={ioType}
                      onSelect={this.onSelectChange.bind(this, "ioType")}
                      IntegrationReactSelectNewLabel="Input / Output Type"
                      errorText={
                        this.state.ioType === "" && this.state.showErrorMessage
                          ? "Please select Input / output type"
                          : ""
                      }
                    />
                  </div>
                ) : null}
              </div>

              <div
                className="col-6 mt-3 mb-3"
                style={{
                  paddingRight: "0px",
                  marginRight: "5px",
                  marginLeft: "5px",
                }}
              >
                <IntegrationReactSelectNew
                  placeholder="Connection Type"
                  multipleSelect={true}
                  someText={[]}
                  content={connTypeStat}
                  onSelect={this.onSelectChange.bind(this, "connType")}
                  IntegrationReactSelectNewLabel="Connection Type"
                  haveDefault={true}
                  defaultValue={[]}
                  errorText={
                    this.state.deviceConnectionType === "" &&
                    this.state.showErrorMessage
                      ? "Please select connection type"
                      : ""
                  }
                />
              </div>

              <div className="col-12 m-0 p-0">
                {this.renderBoxTypeFirst(this.props.redux.auth.deviceApi)}
                {/* {this.state.validateDriverData ? this.state.errorInJSON ? <div className="text-danger">Not a valid driver data.</div> : <div className="text-success">Driver data validated.</div> : ''} */}
              </div>

              {/* Driver Section - Optional */}
              <div className="col-12 mt-4">
                <h5 style={{ color: "#888888", marginBottom: "20px" }}>
                  Driver Information (Optional)
                </h5>
              </div>

              <div className="col-6 mt-3 pl-1">
                <IntegrationReactSelectNew
                  placeholder=""
                  multipleSelect={false}
                  content={deviceDriverList}
                  onSelect={this.onSelectChange.bind(this, "deviceDriver")}
                  IntegrationReactSelectNewLabel="Device Driver"
                  errorText=""
                />
              </div>

              <div className="col-6 mb-2 px-0" style={{ padding: "4px" }}>
                <TextField
                  fullWidth
                  label="Driver Version"
                  placeholder="Driver Version (e.g., 1.0.0)"
                  value={this.state.driverVersion || ""}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Remove any non-digit/non-dot characters
                    value = value.replace(/[^0-9.]/g, "");

                    // Regex for strict X.Y.Z
                    const versionRegex = /^\d+\.\d+\.\d+$/;

                    this.setState({
                      driverVersion: value,
                      driverVersionError: value && !versionRegex.test(value),
                    });
                  }}
                  error={this.state.driverVersionError}
                  helperText={
                    this.state.driverVersionError
                      ? "Version format must be X.Y.Z (e.g., 1.0.0)"
                      : ""
                  }
                />
              </div>

              <div className="col-6">
                <Box>
                  <label
                    htmlFor="package-upload"
                    style={{
                      fontWeight: "bold",
                      display: "block",
                      paddingTop: "0px",
                      paddingBlockStart:"40px",
                      marginBottom: "4px",
                      color: "#666",
                    }}
                  >
                    Upload Package Path
                  </label>
                  <input
                    style={{
                      padding: "10px",
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    id="package-upload"
                    type="file"
                    accept=".zip,.bin"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      this.setState({ packagePath: file || "" });
                    }}
                  />
                </Box>
              </div>

              <div className="col-6">
                <Box>
                  <label
                    htmlFor="document-upload"
                    style={{
                      fontWeight: "bold",
                      display: "block",
                      paddingBlockStart:"40px",
                      marginBottom: "4px",
                      color: "#666",
                    }}
                  >
                    Upload Document
                  </label>
                  <input
                    style={{
                      padding: "10px",
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                    id="document-upload"
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      this.setState({ document: file || "" });
                    }}
                  />
                </Box>
              </div>

              {/* Add Driver Button */}
              <div className="col-12 mt-3">
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    const {
                      deviceDriver,
                      driverVersion,
                      packagePath,
                      document,
                    } = this.state;

                    // Check if any driver field is filled
                    const hasAnyDriverData =
                      deviceDriver || driverVersion || packagePath || document;

                    if (!hasAnyDriverData) {
                      alert(
                        "Please fill at least one driver field to add a driver."
                      );
                      return;
                    }

                    // If any field is filled, all must be filled
                    if (
                      !deviceDriver ||
                      !driverVersion ||
                      !packagePath ||
                      !document
                    ) {
                      alert(
                        "All driver fields are required when adding a driver."
                      );
                      return;
                    }

                    const versionRegex = /^\d+\.\d+\.\d+$/;
                    if (!versionRegex.test(driverVersion)) {
                      alert("Version format must be X.Y.Z (e.g., 1.0.0)");
                      return;
                    }

                    const newItem = {
                      deviceDriver,
                      driverVersion,
                      packagePath,
                      document,
                    };

                    this.setState({
                      itemList: [newItem],
                      deviceDriver: "",
                      driverVersion: "",
                      packagePath: "",
                      document: "",
                      fileErrorText: "",
                      driverVersionError: false,
                    });

                    // Reset file inputs
                    document.getElementById("package-upload").value = "";
                    document.getElementById("document-upload").value = "";
                  }}
                >
                  Add Driver
                </Button>
                <FormHelperText style={{ marginTop: "5px", color: "#666" }}>
                  Driver information is optional. Leave blank if not applicable.
                </FormHelperText>
              </div>

              {/* Show Added Driver List */}
              {this.state.itemList && this.state.itemList.length > 0 && (
                <div className="col-12 mt-3">
                  <h6 style={{ color: "#888888" }}>Added Driver</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped table-sm">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Device Driver</th>
                          <th>Driver Version</th>
                          <th>Package Path</th>
                          <th>Document</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.itemList.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.deviceDriver}</td>
                            <td>{item.driverVersion}</td>
                            <td>
                              {item.packagePath instanceof File
                                ? item.packagePath.name
                                : item.packagePath}
                            </td>
                            <td>
                              {item.document instanceof File
                                ? item.document.name
                                : item.document}
                            </td>
                            <td>
                              <Button
                                size="small"
                                color="secondary"
                                onClick={() => {
                                  this.setState({
                                    itemList: [],
                                  });
                                }}
                              >
                                Remove
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Error Messages */}
              {this.state.errorMessage.length > 0 && (
                <div className="col-12 mt-3">
                  <div className="alert alert-danger">
                    <ul className="mb-0">
                      {this.state.errorMessage.map((error, index) => (
                        <li key={index}>{error}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div className="row w-100 my-3">
                <div className="ml-auto">
                  <button
                    className="btn btn-new-grey"
                    style={{ marginRight: "15px" }}
                    onClick={this.closeModal}
                  >
                    Cancel
                  </button>
                  {this.state.validateDriverData ? (
                    this.state.errorInJSON ? (
                      <button
                        className="btn btn-new-orange float-right"
                        onClick={this.validateDriverData.bind(this)}
                      >
                        Validate Driver Data
                      </button>
                    ) : (
                      <button
                        className="btn btn-new-green"
                        onClick={this.AddDevice.bind(this)}
                        style={{ marginLeft: "15px" }}
                      >
                        Add Device
                      </button>
                    )
                  ) : (
                    <button
                      className="btn btn-new-orange float-right"
                      onClick={this.validateDriverData.bind(this)}
                    >
                      Validate Driver Data
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenSuccess}
          style={customStylesSuccess}
          className={this.state.modalStateAftereOpenSuccess}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div
              className="float-right cross-times"
              onClick={this.closeModalSuccess}
            >
              <i className="fas fa-times fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">
              Device added successfully
            </h3>
            <i className="fas fa-check-circle update"></i>
            <br />
            <div
              className="btn reset-btn mx-2 px-5"
              onClick={this.closeModalSuccess}
            >
              Close
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

AddDeviceNew1.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchBarActivate: (data) =>
      dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    deviceUpdate: (data) => dispatch({ type: ActionTypes.DEVICE, data: data }),
    deviceError: (data) =>
      dispatch({ type: ActionTypes.DRIVERERROR, data: data }),
    deviceErrorClean: (data) =>
      dispatch({ type: ActionTypes.DRIVERERRORCLEAN, data: data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddDeviceNew1));
